import React from 'react';
import { motion } from 'framer-motion';
import { cn } from '../../lib/utils';
interface FadeInProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
}
export const FadeIn = ({
  children,
  delay = 0,
  className,
  direction = 'up'
}: FadeInProps) => {
  const directionOffset = {
    up: {
      y: 30,
      x: 0
    },
    down: {
      y: -30,
      x: 0
    },
    left: {
      x: 30,
      y: 0
    },
    right: {
      x: -30,
      y: 0
    },
    none: {
      x: 0,
      y: 0
    }
  };
  return <motion.div initial={{
    opacity: 0,
    ...directionOffset[direction]
  }} whileInView={{
    opacity: 1,
    x: 0,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    delay: delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={cn(className)} data-id="element-252">
      {children}
    </motion.div>;
};